import { render } from "./BuekTaskIframe.vue?vue&type=template&id=3921995c&ts=true"
import script from "./BuekTaskIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekTaskIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__